import React from 'react';

import CallToAction from '../CallToAction';
import Image from '../Image/GatsbyImage';
import Icon from '../../molecules/Icon';

import {
  Bar,
  Wrapper,
  Content,
  Heading,
  IconWrapper,
  Buttons,
  CloseButton,
} from './styles';

const AnnouncementBar = ({ theme, alignment, icon, text, buttons }) => {
  const handleClick = e => {
    e.preventDefault();

    const bar = document.getElementById('announcement-bar');
    bar.style.display = 'none';
  };

  return (
    <Bar id="announcement-bar" theme={theme}>
      <Wrapper theme={theme} alignment={alignment}>
        <Content>
          {icon && (
            <IconWrapper theme={theme}>
              <Image
                src={icon?.gatsbyImageData || icon?.url}
                alt={icon?.alt}
                width="24px"
                height="24px"
              />
            </IconWrapper>
          )}
          {text && (
            <Heading dangerouslySetInnerHTML={{ __html: text }} theme={theme} />
          )}
        </Content>
        <Buttons>
          {buttons?.map(button => {
            return (
              <CallToAction
                variant="Filled - White"
                size="md"
                {...button}
                styles={{ whiteSpace: 'nowrap' }}
              />
            );
          })}
          <CloseButton
            type="button"
            aria-label="Close Announcement Bar"
            theme={theme}
            onClick={e => handleClick(e)}
          >
            <Icon id="x-close" width="20px" height="20px" />
          </CloseButton>
        </Buttons>
      </Wrapper>
    </Bar>
  );
};

export default AnnouncementBar;
